import { defineMessages } from "react-intl";

const messages = defineMessages({
    alreadyHaveAccount: {
        description: "Already have an account",
        defaultMessage: "Already have an account? {link}"
    },
    loginLink: {
        description: "Link to log in",
        defaultMessage: "Log in"
    }
});

export default messages;
